import { ACTION_COPY, ACTION_DELETE, ACTION_EDIT } from './model'

export const getActions = (state, handlers) => {
  const { actions, template } = state
  const { handleCopy, handleDelete, handleEdit } = handlers

  return actions.map(action => {
    const mapTypeToOnClick = {
      [ACTION_EDIT]: () => handleEdit({ template }),
      [ACTION_COPY]: () => handleCopy({ template }),
      [ACTION_DELETE]: () => handleDelete({ template }),
    }

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
    }
  })
}
